import enMessages from '@/locales/en-US/messages.json';
import nbMessages from '@/locales/nb-NO/messages.json';

// Use AbstractIntlMessages to allow for partial translations
export const messages: Record<string, any> = {
  'en-US': enMessages,
  'nb-NO': nbMessages,
};

// Map short language codes to full locale codes
export const langToLocale: Record<string, string> = {
  en: 'en-US',
  nb: 'nb-NO',
};
